/*
 * This file controls the automatic form functionality of the sidebar
 * found on the RangePage.
 */
const sidebars = Array.from(document.querySelectorAll(".sidebar, .mobile-filter"));

function prepareSidebar(sidebar) {

    const form = sidebar.querySelector("form");

    const checkboxes = Array.from(
        sidebar.querySelectorAll('input[type="checkbox"]:not(.sidebar-block-trigger):not([name="mobile"])')
    );

    if (checkboxes.length) {
        checkboxes.forEach(input => {
            input.addEventListener('change', () => {
                form.submit()
            })
        })
    }

    const search = document.querySelector('.items-section__topbar .search form')

    search.addEventListener('submit', (e) => {
        e.preventDefault()
        if (form.querySelector('[name="query"]')) {
            form.querySelector('[name="query"]').setAttribute('value', search.querySelector('input').value)
            form.submit()
        }
    })

}

function init() {

    if (!sidebars.length) {
        return;
    }

    sidebars.forEach(prepareSidebar);
}

init();
